import React from 'react';

import FieldRenderer from './fieldRenderer';

const displayLegend = (fieldset) =>
  fieldset.fields.reduce((previous, current) => {
    if (current.field_type === 'text') {
      if (previous) return previous;
      if (current.options && current.options.show_label !== undefined) {
        return current.options.show_label;
      }
      return true;
    }
    return previous || Boolean(current.options && current.options.show_label);
  }, false);

function Fieldset({ fields, fieldset, formId, contentArticleFormId }) {
  const classList = fieldset.title && fieldset.title !== 'Hidden-Tracking' ? '' : 'hidden';
  const canUsePlaceholders = 'placeholder' in document.createElement('input');
  const usePlaceholders = fields.show_placeholder_as_label && canUsePlaceholders;
  let legend = null;

  if (displayLegend(fieldset)) {
    legend = (
      <div className="wrapper">
        <legend className="cluster-headline">{fieldset.title}</legend>
      </div>
    );
  }

  return (
    <fieldset className={`form-cluster fieldset-${fieldset.id} ${classList}`}>
      {legend}
      {FieldRenderer.chooseFor(
        fieldset.fields,
        parseInt(formId || fields.id, 10),
        fieldset.required_fields || [],
        usePlaceholders,
        parseInt(contentArticleFormId, 10),
        fields.consultant.table
      )}
    </fieldset>
  );
}

Fieldset.propTypes = {
  fields: React.PropTypes.object.isRequired,
  fieldset: React.PropTypes.object.isRequired,
  formId: React.PropTypes.string,
  contentArticleFormId: React.PropTypes.string
};

export default Fieldset;



// WEBPACK FOOTER //
// ./components/forms/Fieldset.js